import { render, staticRenderFns } from "./SessionCompatibilityBlock.vue?vue&type=template&id=bac81386&scoped=true&"
import script from "./SessionCompatibilityBlock.vue?vue&type=script&lang=js&"
export * from "./SessionCompatibilityBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac81386",
  null
  
)

export default component.exports